import { render, staticRenderFns } from "./Game_Notice.vue?vue&type=template&id=527fb532&scoped=true&"
import script from "./Game_Notice.vue?vue&type=script&lang=js&"
export * from "./Game_Notice.vue?vue&type=script&lang=js&"
import style0 from "./Game_Notice.vue?vue&type=style&index=0&id=527fb532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fb532",
  null
  
)

export default component.exports